var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPageTranslated = function SvgPageTranslated(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6A89A6",
    fillRule: "evenodd",
    d: "M5 2.5a.833.833 0 0 0-.833.833v13.334c0 .46.373.833.833.833h10c.46 0 .833-.373.833-.833v-10a.833.833 0 0 0-.244-.59l-3.333-3.333a.833.833 0 0 0-.59-.244H5Zm.833 13.334V4.167h5.489l2.845 2.845v8.822H5.833ZM7.5 10a.833.833 0 0 0 0 1.667h5a.833.833 0 0 0 0-1.667h-5Zm-.833-1.667c0-.46.373-.833.833-.833h3.333a.833.833 0 1 1 0 1.667H7.5a.833.833 0 0 1-.833-.834ZM7.5 12.5a.833.833 0 0 0 0 1.667h5a.833.833 0 0 0 0-1.667h-5Z",
    clipRule: "evenodd"
  })));
};
export default SvgPageTranslated;